import script from "./ConfirmStocOneClickkModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./ConfirmStocOneClickkModal.vue?vue&type=script&lang=ts&setup=true"

import "./ConfirmStocOneClickkModal.vue?vue&type=style&index=0&id=a14e59ae&lang=scss"
import "./ConfirmStocOneClickkModal.vue?vue&type=style&index=1&id=a14e59ae&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a14e59ae"]])

export default __exports__